import CreationSelection from '../../components/CreationSelection/CreationSelection';

function Home() {
  return (
    <>
      <CreationSelection />
    </>
  );
}

export default Home;
